if (!customElements.get("localization-form")) {
  customElements.define(
    "localization-form",
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.mql = window.matchMedia("(min-width: 750px)");
        this.header = document.querySelector(".header-wrapper");
        this.elements = {
          input: this.querySelector(
            'input[name="locale_code"], input[name="country_code"]',
          ),
          button: this.querySelector("button.localization-form__select"),
          panel: this.querySelector(".disclosure__list-wrapper"),
        };
        this.handleDocumentClick = this.handleDocumentClick.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);
        this.elements.button.addEventListener(
          "click",
          this.openSelector.bind(this),
        );

        // Items are <button data-value>, not links — match on the attribute the handler actually reads.
        this.querySelectorAll("[data-value]").forEach((item) =>
          item.addEventListener("click", this.onItemClick.bind(this)),
        );
      }

      hidePanel() {
        this.elements.button.setAttribute("aria-expanded", "false");
        this.elements.panel.setAttribute("hidden", true);
        document.body.classList.remove("overflow-hidden-mobile");
        document
          .querySelector(".menu-drawer")
          ?.classList.remove("country-selector-open");
        if (this.header) this.header.preventHide = false;
        document.removeEventListener("click", this.handleDocumentClick);
        document.removeEventListener("keydown", this.handleKeydown);
      }

      onItemClick(event) {
        event.preventDefault();
        const form = this.querySelector("form");
        this.elements.input.value = event.currentTarget.dataset.value;
        if (form) form.submit();
      }

      openSelector() {
        this.elements.button.focus();
        this.elements.panel.toggleAttribute("hidden");
        this.elements.button.setAttribute(
          "aria-expanded",
          (
            this.elements.button.getAttribute("aria-expanded") === "false"
          ).toString(),
        );
        if (!document.body.classList.contains("overflow-hidden-tablet")) {
          document.body.classList.add("overflow-hidden-mobile");
        }
        if (this.hasAttribute("data-prevent-hide") && this.header) {
          this.header.preventHide = true;
        }
        document
          .querySelector(".menu-drawer")
          ?.classList.add("country-selector-open");
        document.addEventListener("click", this.handleDocumentClick);
        document.addEventListener("keydown", this.handleKeydown);
      }

      handleDocumentClick(event) {
        if (!this.contains(event.target)) {
          this.hidePanel();
        }
      }

      handleKeydown(event) {
        if (event.key === "Escape") {
          this.hidePanel();
          this.elements.button.focus();
        } else if (event.key === "Tab" && !this.contains(event.target)) {
          this.hidePanel();
        }
      }
    },
  );
}
